import styled from 'styled-components';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';

export const CompletedInvestmentWorkflowText = styled(Text)`
	margin-bottom: 1rem;
`;

export const ActionButtonsWrapper = styled.div`
	display: flex;
	gap: 1rem;
`;
